import React from 'react';
import { Select, TextInput } from '@mantine/core';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import InspectorRow from '../../../puck/fields/InspectorRow';
import { PuckColorFieldWithPalette } from '../../../puck/fields/createPuckColorField';

/** Variantes Mantine du composant Badge (reprises de l'ancienne Liste de badges). */
export const BADGE_VARIANT_OPTIONS = [
  { label: 'Clair', value: 'light' },
  { label: 'Plein', value: 'filled' },
  { label: 'Contour', value: 'outline' },
  { label: 'Point', value: 'dot' },
];

/**
 * Champ « Badges » de la Carte info — liste repliable partagée. Libellé,
 * couleur et variante sont des attributs atomiques stylés par Mantine (pas du
 * texte riche) : ils restent en sidebar, comme les liens du footer.
 */
export default function InfoCardBadgesField({ value, onChange }) {
  return (
    <CollapsibleListField
      value={value}
      onChange={onChange}
      addLabel="Ajouter un badge"
      createItem={(count) => ({ label: `Badge ${count + 1}`, color: '', variant: 'light' })}
      itemTitle={(badge, index) => badge.label || `Badge ${index + 1}`}
      renderItem={(badge, update) => (
        <>
          <TextInput
            size="xs"
            label="Libellé"
            value={badge.label || ''}
            onChange={(e) => update({ label: e.target.value })}
          />
          {/* Vide = couleur principale du thème de la proposal. */}
          <InspectorRow label="Couleur">
            <PuckColorFieldWithPalette
              label={null}
              value={badge.color || ''}
              onChange={(color) => update({ color: color ?? '' })}
              allowTransparent
            />
          </InspectorRow>
          <Select
            size="xs"
            label="Style"
            data={BADGE_VARIANT_OPTIONS}
            value={badge.variant || 'light'}
            onChange={(variant) => {
              if (variant) update({ variant });
            }}
            allowDeselect={false}
            comboboxProps={{ withinPortal: true }}
          />
        </>
      )}
    />
  );
}
